interface SEOHeadProps {
  title: string;
  description: string;
  keywords?: string;
  path?: string;
  ogType?: string;
  ogImage?: string;
  lastModified?: string;
}

/**
 * React 19 renders <title>, <meta>, <link> elements and hoists them to <head>
 * automatically — no library needed.
 */
export default function SEOHead({
  title,
  description,
  keywords,
  path = "",
  ogType = "website",
  ogImage,
  lastModified = "2026-03-30",
}: SEOHeadProps) {
  const siteUrl = (import.meta.env.VITE_SITE_URL as string | undefined) ?? "";
  const canonicalUrl = `${siteUrl}${path}`;

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="last-modified" content={lastModified} />
      <link rel="canonical" href={canonicalUrl} />
      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:site_name" content="The Magazine Co." />
      {ogImage && <meta property="og:image" content={ogImage} />}
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {ogImage && <meta name="twitter:image" content={ogImage} />}
    </>
  );
}
